import { gql } from '@apollo/client'

export const TreasurePoolFragment = gql`
  fragment TreasurePool on ExpeditionTreasurePool {
    previewInfo
    requireStakeKey
    stDescriptionKey
    stType
    totalRewardTreasure
  }
`
